<template>
  <el-timeline-item :timestamp="getformatDate" placement="top">
    <el-card shadow="always" class="box-card b-rad-13">
      <div class="foo">
        <el-avatar v-if="img" size="small" :src="img"></el-avatar>
        <el-avatar
          v-else
          size="small"
          src="/static/images/avatar-2.jpg"
        ></el-avatar>
        <span>{{ content }}</span>
      </div>
    </el-card>
  </el-timeline-item>
</template>

<script>
import { formatDate } from "@/utils";
export default {
  name: "CommentBox",
  props: {
    content: {
      type: String
    },
    img: {
      type: String,
      required: false,
      default: null
    },
    date: {
      type: String,
      default: "00/00/00"
    }
  },
  data() {
    return {
      commentDate: "",
      commentTime: ""
    };
  },
  computed: {
    getformatDate() {
      return formatDate(this.date);
    }
  }
};
</script>

<style lang="scss" scoped>
.foo {
  height: auto;

  span {
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  }

  span:first-child {
    margin-right: var(--flex-gap, 0.5em);
  }
}

.box-card {
  width: 430px;
}
</style>
